<vex-page-layout>
    <vex-page-layout-header class="pb-16 flex flex-col items-start justify-center">
        <div [class.px-gutter]="true" class="w-full flex flex-col sm:flex-row justify-between">
            <div>
                <h1 class="title mt-0 mb-1">Monitores</h1>
                <vex-breadcrumbs [crumbs]="crumbs"></vex-breadcrumbs>
            </div>
        </div>
    </vex-page-layout-header>

    <vex-page-layout-content [class.px-gutter]="true" class="-mt-6">
        <div class="card overflow-auto -mt-16">
            <div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">
                <div
                    class="bg-foreground rounded-full border px-4 max-w-[300px] flex-auto flex items-center border border-gray-300">
                    <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
                    <input [(ngModel)]="searchKey" (keyup)="applyFilter($event)" autocomplete="off"
                        class="px-4 py-2 border-0 outline-none w-full bg-transparent" placeholder="Buscar..."
                        type="search">
                </div>
                <span class="flex-1"></span>
                <button mat-icon-button type="button" matTooltip="Ver el display" (click)="display()">
                    <mat-icon class="text-secondary" svgIcon="mat:tv"></mat-icon>
                </button>
                <button mat-icon-button type="button" matTooltip="Exportar a pdf" (click)="downloadPdf()">
                    <mat-icon class="text-secondary" svgIcon="mat:picture_as_pdf"></mat-icon>
                </button>
                <button mat-icon-button type="button" matTooltip="Exportar a Excel"
                    (click)="exporter.exportTable('xlsx', {fileName: 'desaparecidos'})">
                    <mat-icon class="text-secondary" svgIcon="mat:file_copy"></mat-icon>
                </button>
                <button (click)="loadList()" class="ml-4 flex-none" color="primary" mat-mini-fab
                    matTooltip="Actualizar" type="button">
                    <mat-icon svgIcon="mat:sync"></mat-icon>
                </button>
                <button (click)="create()" class="ml-4 flex-none" color="primary" 
                    mat-mini-fab matTooltip="Agregar monitor"
                    type="button">
                    <mat-icon svgIcon="mat:add"></mat-icon>
                </button>
            </div>
            <table [dataSource]="dataSource" class="w-full" mat-table matSort matTableExporter
                #exporter="matTableExporter">
                <ng-container matColumnDef="nombre">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Nombre</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.nombre }}</td>
                </ng-container>
                <ng-container matColumnDef="direccion">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Dirección</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.direccion }}</td>
                </ng-container>
                <ng-container matColumnDef="codigo">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Código</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.codigo}}</td>
                </ng-container>
                <ng-container matColumnDef="estado">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Estado</th>
                    <td *matCellDef="let element" mat-cell>
                        <div (click)="$event.stopPropagation()" class="flex items-center gap-1">
                            <div [ngClass]="element.estado? [stateConstant.SUCCESS_TEXT_CLASS, stateConstant.SUCCESS_BG_CLASS]: [stateConstant.ERROR_TEXT_CLASS, stateConstant.ERROR_BG_CLASS]"
                                class="rounded px-2 py-1 font-medium text-xs flex-none">
                                {{element.estado?'Conectado':'Desconectado'}}
                            </div>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="fechaRegistro">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Fecha registro</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.fechaRegistro }}</td>
                </ng-container>
                <ng-container matColumnDef="usuarioRegistro">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Usuario</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.usuarioRegistro }}</td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header></th>
                    <td *matCellDef="let row" class="w-10 text-secondary" mat-cell>
                        <button (click)="$event.stopPropagation()" [matMenuTriggerData]="{ customer: row }"
                            [matMenuTriggerFor]="actionsMenu" mat-icon-button type="button">
                            <mat-icon svgIcon="mat:more_horiz"></mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="appSettings.PAGE_SIZE_OPTIONS" [pageSize]="appSettings.PAGE_SIZE"
                class="sticky left-0"></mat-paginator>
        </div>
    </vex-page-layout-content>
</vex-page-layout>
<mat-menu #actionsMenu="matMenu" xPosition="before" yPosition="below">
    <ng-template let-customer="customer" matMenuContent>
        <button (click)="edit(customer)" mat-menu-item>
            <mat-icon svgIcon="mat:edit"></mat-icon>
            <span>Editar</span>
        </button>
        <button (click)="delete(customer)" mat-menu-item>
            <mat-icon svgIcon="mat:delete"></mat-icon>
            <span>Eliminar</span>
        </button>
    </ng-template>
</mat-menu>
